import * as React from 'react'
import ReactSelect from 'react-select'

export interface ITourSkillOption {
  value: string
  label: string
}

interface IProps {
  options: ITourSkillOption[]
  value: string | null
  placeholder?: string
  isClearable?: boolean
  isDisabled?: boolean
  className?: string
  onChange(value: string | null): void
}

// ツアースキル選択用のテキスト検索可能な単一選択セレクト。
// モーダル/ドロワー内でも使えるよう menu は body にポータルで出す。
// 幅・高さの微調整は親の styled-components から classNamePrefix(tourSkillSingleSelect)で行う。
const TourSkillSingleSelect: React.VFC<IProps> = ({
  options,
  value,
  onChange,
  placeholder,
  isClearable = false,
  isDisabled = false,
  className,
}) => (
  <ReactSelect
    className={className}
    classNamePrefix="tourSkillSingleSelect"
    options={options}
    value={options.find(option => option.value === value) ?? null}
    isMulti={false}
    isClearable={isClearable}
    isDisabled={isDisabled}
    placeholder={placeholder}
    onChange={option => onChange(option ? option.value : null)}
    menuPortalTarget={document.querySelector('body')}
    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
  />
)

export default TourSkillSingleSelect
